import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowDownOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowDownOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M13 16.97V3.89h-2v13.08l-8-5.6v2.44l9 6.3 9-6.3v-2.44l-8 5.6Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowDownOutlined;